module.exports = __webpack_public_path__ + "img/ky1.2265504d.png";